import { combineReducers } from '@reduxjs/toolkit'

import { reducer as loginReducer } from './login'
// import { reducer as requestPasswordResetReducer } from './requestPasswordReset';
// import { reducer as resetPasswordReducer } from './resetPassword';

export { login, logout } from './login'
// export { requestPasswordReset, resetRequestPasswordReset } from './requestPasswordReset';
// export { resetPassword, resetResetPassword } from './resetPassword';

export const reducer = combineReducers({
  login: loginReducer,
  // requestPasswordReset: requestPasswordResetReducer,
  // resetPassword: resetPasswordReducer,
})
